/**
 * @see displayModeObjects.js for more information
 */
export default () => window.documentViewer.getDisplayModeManager().getDisplayMode().IsScrollable();
